import {
  BarChartOutlined,
  CreditCardOutlined,
  FileExcelOutlined,
  FileTextOutlined,
  LogoutOutlined,
  PhoneOutlined,
  SwapOutlined,
  TagOutlined,
  TeamOutlined,
  TrophyOutlined,
} from "@ant-design/icons";
import Link from "antd/es/typography/Link";

export const NAME_VARIABLES = {
  EMAIL: "Email",
  USERNAME: "Username",
  PASSWORD: "Contraseña",
};

export const GENERAL = {
  PAGE_NAME: "Rifas Gran Familia Guadalajara",
  SPACE: " ",
  PLACE: "Guadalajara, Jalisco.",
  WEB_PAGE: "www.rifasgranfamiliagdl.com.mx",
};

export const BUTTONS = {
  BUTTON_LOGIN: "Ingresar",
};

export const HOME_HEADER = {
  TITLE_1: "COMPRA",
  TITLE_2: "EN LINEA",
  SUBTITLE: "ENTRA A",
  WEBSITE: "www.rifasgranfamiliagdl.com.mx",
};

export const WE_ARE_SECTION = {
  // TITLE: "¿Quiénes Somos?",
  TITLE: "Nuestra Promesa",
  DESCRIPTION_1:
    "Sorteos RIFAS GRAN FAMILIA GDL se basa en la LOTERIA NACIONAL MEXICANA",
  DESCRIPTION_2: "¡INVIERTE POCO, GANA EN GRANDE!",
};

export const QUESTIONS = {
  TITLE: "Preguntas Frecuentes",
  LIST: [
    {
      key: "1",
      label: "¿CÓMO SE ELIGE A LOS GANADORES?",
      children: (
        <>
          Todos nuestros sorteos se realizan en base a la{" "}
          <Link
            href="https://www.loterianacional.gob.mx/Billete/CalendarioSorteos"
            target="_blank"
          >
            Lotería Nacional para la Asistencia Pública Mexicana.
          </Link>
          <br />
          <br />
          El ganador de 'RIFAS GRAN FAMILIA GDL' será el participante cuyo
          número de boleto coincida con las últimas cifras del primer premio
          ganador de la Lotería Nacional (las fechas serán publicadas en
          nuestros medios oficiales).
        </>
      ),
    },
    {
      key: "2",
      label: "¿QUÉ SUCEDE CUANDO EL NÚMERO GANADOR ES UN BOLETO NO VENDIDO?",
      children: (
        <>
          Se elige un nuevo ganador realizando la misma dinámica en otra fecha
          cercana (se anunciará la nueva fecha en los medios oficiales).
          <br />
          <br />
          Esto significa que, ¡Tendrías el doble de oportunidades de ganar con
          tu mismo boleto!
        </>
      ),
    },
    {
      key: "3",
      label: "¿DÓNDE SE PUBLICAN A LOS GANADORES?",
      children: (
        <>
          En nuestra página oficial de Facebook{" "}
          <Link href="https://www.facebook.com/share/1BzuzWbdrC/?mibextid=wwXIfr" target="_blank">
            RIFAS GRAN FAMILIA GDL
          </Link>{" "}
          puedes encontrar todos y cada uno de nuestros sorteos anteriores, así
          como las transmisiones en vivo con Lotería Nacional y las entregas de
          premios a los ganadores!
        </>
      ),
    },
    {
      key: "4",
      label: "¿ES POSIBLE CONSULTAR AL GANADOR DE UN SORTEO PASADO?",
      children: (
        <>
          ¡Claro que sí! Todos los ganadores del premio mayor de nuestros
          sorteos anteriores están disponibles en esta página web, dentro de la
          sección de{" "}
          <Link href="/ganadores" target="_blank">
            ganadores.
          </Link>
        </>
      ),
    },
  ],
};

export const CONTACT_US = {
  TITLE: "Contáctanos",
  DESCRIPTION:
    "¡Estamos listos para ayudarte! ¿Tienes dudas sobre tu boleto, los sorteos o simplemente quieres saludarnos? \nElige tu forma de contacto preferida.",
};

export const COUPLE = {
  TITLE_ONE: "¿Aún no sabes que boletos pedir?",
  BUTTON_ONE: "Escoger Boletos",
  TITLE_TWO: "¿Tienes dudas acerca del sorteo?",
  BUTTON_TWO: "Sección de preguntas",
};

export const PAY_METHODS = {
  TITLE: "Métodos de pago",
  DESCRIPTION:
    "Realiza tu pago mediante cualquiera de las siguientes opciones y envía el comprobante al número de WhatsApp que prefieras.",
  WARNING: {
    TITLE: "Advertencias importantes",
    RULES: [
      "Se aceptan únicamente transferencias bancarias y pagos realizados en cajero automático.",
      "Tu nombre debe aparecer obligatoriamente en el concepto de pago.",
      "Si alguna cuenta se encuentra saturada, por favor intenta con otra.",
      "¡No olvides enviar tu comprobante para validar tu compra!"
    ],
  },
  LABEL: "Equipo de Pagos",
  WHATSAPPS: [
    {
      title: "+52 333-142-3091",
      phone: 523331423091,
    },
    {
      title: "+52 333-142-3092",
      phone: 523331423092,
    },
    {
      title: "+52 333-142-3093",
      phone: 523331423093,
    },
  ],
};

export const VERIFIER = {
  TITLE: "Verificador de boletos",
  DESCRIPTION: "Ingresa el número de boleto que deseas verificar.",
  BUTTON_VERIFIER: "Verificar",
  BUTTON_LABEL: "Volver al inicio",
  ERRORS: {
    TITLE_TICKET: "Lo sentimos, el ticket que buscas no fue encontrado.",
    TITLE_PHONE: "Lo sentimos, el número de teléfono que buscas no fue encontrado.",
    DESCRIPTION_TICKET: "Por favor, verifica que el número de boleto sea correcto y vuelve a intentarlo.",
    DESCRIPTION_PHONE: "Por favor, verifica que el número de teléfono sea correcto y vuelve a intentarlo.",
  }
};

export const TICKET = {
  LOTTO_BADGE: "SORTEO",
  INFO_BADGE: "INFORMACIÓN",
  LUCKY_MESSAGE: "¡MUCHA SUERTE!"
}

export const PRIVACY = {
  GENERAL: {
    TITLE: "INFORMACIÓN GENERAL",
    TEXT: [
      "Rifas Gran Familia GDL asume el compromiso de respetar las bases establecidas para cada sorteo, así como de garantizar el cumplimiento de sus reglas.",
      "Toda la información e imágenes disponibles en este sitio han sido proporcionadas por Rifas Gran Familia GDL, quien ostenta la responsabilidad total sobre el sitio web, el contenido publicado, la organización de los sorteos y el manejo de la información recopilada o compartida a través del mismo.",
    ],
  },
  PROPECTS: {
    TITLE: "AVISO DE PRIVACIDAD PARA PROSPECTOS",
    CONTENT: [
      {
        SUBTITLE: "DATOS PERSONALES RECABADOS",
        TEXT: [
          "Con el fin de cumplir las finalidades establecidas en este Aviso de Privacidad, Rifas Gran Familia GDL recabará los siguientes datos personales: \n-Datos de identificación \n-Datos de contacto",
          "Estos datos pueden ser obtenidos directamente de usted o, en algunos casos, de fuentes de acceso público.",
          "Rifas Gran Familia GDL no recabará ni tratará datos personales sensibles para las finalidades descritas en este aviso.",
        ],
      },
      {
        SUBTITLE: "USO DE LOS DATOS PERSONALES",
        TEXT: [
          "Finalidades primarias:",
          "Los datos personales proporcionados serán utilizados para: \n-Identificarle y registrarle como prospecto de venta. \n-Evaluar su elegibilidad para adquirir nuestros productos o servicios. \n-Contactarle por medios físicos o electrónicos para ofrecerle nuestros productos y servicios. \n-Atender sus solicitudes de información o cualquier otra gestión relacionada con nuestra actividad. \n-Cumplir con obligaciones legales y colaborar con autoridades competentes cuando sea requerido.",
          "Finalidades secundarias:",
          "Adicionalmente, y salvo que usted manifieste lo contrario, podremos utilizar sus datos para: \n-Establecer contacto en futuras ocasiones. \n-Enviar información promocional sobre eventos, novedades y servicios. \n-Realizar estudios de mercado y actividades de promoción. \n-Generar estadísticas internas.",
        ],
      },
      {
        SUBTITLE:
          "OPCIÓN PARA RECHAZAR EL USO DE DATOS PERSONALES CON FINES SECUNDARIOS",
        TEXT: [
          "Si desea que sus datos no sean utilizados para alguna o todas las finalidades secundarias, puede comunicarse con nosotros a cualquiera de nuestras redes sociales oficiales.",
          "La negativa al uso de sus datos con fines secundarios no afectará la prestación de nuestros servicios ni la relación establecida.",
        ],
      },
      {
        SUBTITLE: "TRANSFERENCIA DE DATOS PERSONALES",
        TEXT: [
          "Rifas Gran Familia GDL únicamente compartirá sus datos personales con: \n\nAutoridades competentes, exclusivamente en los casos legalmente previstos. \nFinalidad: Cumplimiento de obligaciones legales. \nConsentimiento: No requerido.",
        ],
      },
      {
        SUBTITLE: "DERECHOS ARCO Y REVOCACIÓN DEL CONSENTIMIENTO",
        TEXT: [
          "Usted, o su representante legal debidamente acreditado, puede ejercer sus derechos de Acceso, Rectificación, Cancelación y Oposición (ARCO), así como revocar su consentimiento, enviando un mensaje a cualquiera de nuestras redes sociales oficiales.",
          "Para conocer el procedimiento, requisitos y plazos, visite nuestra página: https://rifasgranfamiliagdl.com.mx/aviso-privacidad",
        ],
      },
      {
        SUBTITLE: "LIMITACIÓN DE USO Y DIVULGACIÓN",
        TEXT: [
          "Puede solicitar la limitación del uso o divulgación de sus datos personales enviando su petición a cualquiera de nuestra redes sociales oficiales. Si procede, será incluido en nuestro listado de exclusión.",
        ],
      },
      {
        SUBTITLE: "MODIFICACIONES AL AVISO DE PRIVACIDAD",
        TEXT: [
          "Cualquier cambio o actualización al presente aviso será comunicado a través de nuestra página web: https://rifasgranfamiliagdl.com.mx/aviso-privacidad",
        ],
      },
      {
        SUBTITLE: "USO DE COOKIES",
        TEXT: [
          "Nuestro sitio web emplea tecnologías como cookies para mejorar su experiencia de navegación. Estas permiten recordar sus preferencias y facilitar su interacción con el sitio.",
          "Usted puede desactivar o ajustar el uso de cookies desde la configuración de su navegador.",
        ],
      },
      {
        SUBTITLE: "AUTORIDAD DE PROTECCIÓN DE DATOS",
        TEXT: [
          "En caso de considerar que sus derechos han sido vulnerados, puede acudir al Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI).",
        ],
      },
      {
        SUBTITLE: "ACEPTACIÓN",
        TEXT: [
          "Al proporcionarnos sus datos, usted reconoce haber leído este Aviso de Privacidad y acepta el tratamiento de su información conforme a lo aquí establecido.",
          "Última actualización: 10 de octubre de 2025.",
        ],
      },
    ],
  },
  PARTICIPANTS: {
    TITLE: "AVISO DE PRIVACIDAD PARA PARTICIPANTES",
    CONTENT: [
      {
        SUBTITLE: "DATOS PERSONALES Y DATOS PERSONALES SENSIBLES",
        TEXT: [
          "Rifas Gran Familia GDL recaba datos personales de usuarios, clientes, proveedores y cualquier persona vinculada a sus actividades. Estos datos se clasifican de la siguiente manera: \n-Datos de identificación \n-Datos de contacto \n-Información de tarjetas de crédito",
          "El tratamiento de estos datos es indispensable para cumplir con las obligaciones derivadas de la relación jurídica entre usted y Rifas Gran Familia GDL, por lo que no se requiere su consentimiento expreso.",
        ],
      },
      {
        SUBTITLE: "USO DE LOS DATOS PERSONALES",
        TEXT: [
          "Finalidades primarias: \nLos datos personales serán utilizados para:",
          "-Identificarle como participante. \n-Contactarle en relación con el pago del boleto adquirido y, en su caso, la entrega del premio. \n-Informarle sobre el desarrollo y resultados de los sorteos. \n-Publicar su nombre en nuestras listas de ganadores, si resulta premiado.",
          "Estas finalidades son esenciales para cumplir con la relación establecida, por lo que no es posible solicitar la suspensión de su tratamiento.",
          "Finalidades secundarias: \nUna vez concluido el sorteo en el que usted participe, conservaremos sus datos para:",
          "-Informarle sobre novedades, eventos, promociones y servicios relacionados. \n-Solicitar su opinión para estudios de mercado y promoción de productos. \n-Atender quejas, reclamaciones o consultas. \n-Generar estadísticas internas.",
        ],
      },
      {
        SUBTITLE: "OPCIÓN PARA RECHAZAR EL USO DE DATOS CON FINES SECUNDARIOS",
        TEXT: [
          "Si desea que sus datos no sean utilizados para alguna o todas las finalidades secundarias, puede comunicarse con nosotros a cualquiera de nuestras redes sociales oficiales.",
          "La negativa no afectará la prestación de nuestros servicios ni la relación jurídica existente.",
        ],
      },
      {
        SUBTITLE: "TRANSFERENCIA DE DATOS PERSONALES",
        TEXT: [
          "Rifas Gran Familia GDL únicamente compartirá sus datos personales en los siguientes casos:",
          "-Instituciones bancarias: Para gestionar pagos relacionados con la compra de boletos. \n-Autoridades competentes: En cumplimiento de disposiciones legales. \n-Consentimiento: No requerido.",
        ],
      },
      {
        SUBTITLE: "DERECHOS ARCO Y REVOCACIÓN DEL CONSENTIMIENTO",
        TEXT: [
          "Usted, o su representante legal debidamente acreditado, puede ejercer sus derechos de Acceso, Rectificación, Cancelación y Oposición (ARCO), así como revocar su consentimiento, enviando un mensaje a cualquiera de nuestras redes sociales oficiales.",
          "Para conocer el procedimiento, requisitos y plazos, visite nuestra página: https://rifasgranfamiliagdl.com.mx/aviso-privacidad",
        ],
      },
      {
        SUBTITLE: "LIMITACIÓN DE USO Y DIVULGACIÓN",
        TEXT: [
          "Puede solicitar la limitación del uso o divulgación de sus datos personales enviando su petición a cualquiera de nuestras redes sociales oficiales. Si procede, será incluido en nuestro listado de exclusión.",
        ],
      },
      {
        SUBTITLE: "MODIFICACIONES AL AVISO DE PRIVACIDAD",
        TEXT: [
          "Cualquier cambio o actualización al presente aviso será comunicado a través de nuestra página web: https://rifasgranfamiliagdl.com.mx/aviso-privacidad",
        ],
      },
      {
        SUBTITLE: "USO DE COOKIES",
        TEXT: [
          "Nuestro sitio web utiliza tecnologías como cookies para mejorar su funcionamiento y su experiencia de navegación. Estas permiten recordar sus preferencias y facilitar su interacción con el sitio.",
          "Usted puede desactivar o ajustar el uso de cookies desde la configuración de su navegador.",
        ],
      },
      {
        SUBTITLE: "AUTORIDAD DE PROTECCIÓN DE DATOS",
        TEXT: [
          "Si considera que sus derechos han sido vulnerados, puede acudir al Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI).",
        ],
      },
      {
        SUBTITLE: "ACEPTACIÓN DEL AVISO DE PRIVACIDAD",
        TEXT: [
          "Al utilizar nuestros productos y servicios, usted acepta el tratamiento de sus datos personales conforme a lo establecido en este aviso.",
          "Última actualización: 10 de octubre de 2025",
        ],
      },
    ],
  },
};

export const DASHBOARD = {
  TITLE: "DASHBOARD",
  ITEMS: [
    {
      key: "lottos",
      icon: <TagOutlined />,
      label: "Rifas",
    },
    {
      key: "winners",
      icon: <TrophyOutlined />,
      label: "Ganadores",
    },
    {
      key: "participants",
      icon: <TeamOutlined />,
      label: "Participantes",
    },
    {
      key: "pay_methods",
      icon: <CreditCardOutlined />,
      label: "Métodos de Pago",
    },
    {
      key: "phones",
      icon: <PhoneOutlined />,
      label: "Telefonos",
    },
    {
      key: "movements",
      icon: <SwapOutlined />,
      label: "Movimientos",
    },
    {
      key: "statistics",
      icon: <BarChartOutlined />,
      label: "Estadísticas",
    },
    {
      key: "meta_template",
      icon: <FileTextOutlined />,
      label: "Templates Whatsapp",
    },
    {
      key: "report_ticket_movements",
      icon: <FileExcelOutlined />,
      label: "Descarga Reportes",
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Cerrar sesión",
    },
  ],
};

export const DASHBOARD_PAY_METHODS = {
  TITLE: "Métodos de pago",
  ACTIONS: {
    CREATE_TITLE: "+ Agregar",
    TOOLTIPS: {
      SHOW: "Mostrar",
      EDIT: "Editar",
      ADD: "Agregar",
      UPDATE: "Actualizar",
      SAVE: "Guardar",
    },
  },
  STATUS: {
    ACTIVE: "Activo",
    INACTIVE: "Inactivo",
  },
  COLUMNS: {
    ID: "ID",
    BANK: "Banco",
    NAME: "Nombre",
    CARD_NUMBER: "Núm. Tarjeta",
    STATUS: "Status",
    ACTIONS: "Acciones",
    CARD_TYPE: "Tipo de Tarjeta",
  },
  TITLE_SIMPLE: "Método de pagos",
};

export const DASHBOARD_PHONES = {
  TITLE: "Telefonos",
  ACTIONS: {
    CREATE_TITLE: "+ Agregar",
    TOOLTIPS: {
      SHOW: "Mostrar",
      EDIT: "Editar",
      ADD: "Agregar",
      UPDATE: "Actualizar",
      SAVE: "Guardar",
    },
  },
  STATUS: {
    ACTIVE: "Activo",
    INACTIVE: "Inactivo",
    MAIN: "Principal",
    SECONDARY: "Secundario",
  },
  COLUMNS: {
    ID: "ID",
    LADA: "Lada",
    PHONE: "Telefono",
    OWNER_NAME: "Nombre",
    WHATSAPP_PHONE_ID: "ID WhatsApp",
    MAIN: "Principal",
    STATUS: "Status",
    ACTIONS: "Acciones",
  },
  TITLE_SIMPLE: "Telefonos",
};

export const DASHBOARD_LOTTOS = {
  TITLE: "Nuestras Rifas",
  ACTIONS: {
    CREATE_TITLE: "+ Agregar",
    TOOLTIPS: {
      SHOW: "Mostrar",
      EDIT: "Editar",
      ADD: "Agregar",
      EDIT_STATUS: "Editar Status",
      UPDATE: "Actualizar",
      SAVE: "Guardar",
    },
  },
  STATUS: {
    ACTIVE: "ACTIVE",
    CREATED: "CREATED",
    CLOSED: "CLOSED",
    COMPLETED: "COMPLETED",
    ELIMINATED: "ELIMINATED",
    PENDING: "PENDING",
  },
  COLUMNS: {
    ID: "ID",
    TITLE: "Titulo",
    SUBTITLE: "Descripción",
    TICKET_AMOUNT: "Núm. Tickets",
    TICKET_PRICE: "Precio Ticket",
    OPPORTUNITIES: "Núm. Oport.",
    LOTTO_NUMBER: "Núm. Sorteo",
    LOTTO_DATE: "Fecha Sorteo",
    PUBLISHED_DATE: "Fecha de Pub.",
    STATUS: "Status",
    ACTIONS: "Acciones",
  },
  TITLE_SIMPLE: "Método de pagos",
  AWARDS: {
    COLUMNS: {
      ID: "ID",
      AWARD: "Premio",
      PLACE: "Lugar",
      PLACE_NUMBER: "Num. Lugar",
    },
    ACTIONS: {
      DELETE: "Eliminar",
      ADD: "Agregar",
    },
  },
  BONUSES: {
    COLUMNS: {
      ID: "ID",
      BONUS: "Bonus",
      BONUS_CONDITION: "Condición para Bonus",
      CATEGORY: "Categoría",
    },
    ACTIONS: {
      DELETE: "Eliminar",
      ADD: "Agregar",
    },
  },
};

export const DASHBOARD_WINNERS = {
  TITLE: "Ganadores",
  ACTIONS: {
    CREATE_TITLE: "+ Agregar",
    TOOLTIPS: {
      SHOW: "Mostrar",
      EDIT: "Editar",
      ADD: "Agregar",
      EDIT_STATUS: "Editar Status",
      UPDATE: "Actualizar",
      SAVE: "Guardar",
    },
  },
  STATUS: {
    ACTIVE: "ACTIVE",
    CREATED: "CREATED",
    CLOSED: "CLOSED",
    COMPLETED: "COMPLETED",
    ELIMINATED: "ELIMINATED",
    PENDING: "PENDING",
  },
  COLUMNS: {
    LOTTO_ID: "ID Sorteo",
    LOTTO_TITLE: "Sorteo",
    LOTTO_DATE: "Fecha Sorteo",
    LOTTO_AWARD: "Premio",
    SOCIAL_LINKS: "Links Ganadores",
    FACEBOOK_LINK: "Link Facebook",
    INSTAGRAM_LINK: "Link Instagram",
    TICKET_NUMBER: "Ticket Ganador",
    STATUS: "Status",
    ACTIONS: "Acciones",
  },
};

export const DASHBOARD_META_TEMPLATE = {
  TITLE: "Templates Meta (WhatsApp)",
  ACTIONS: {
    CREATE_TITLE: "+ Agregar",
    TOOLTIPS: {
      SHOW: "Mostrar",
      EDIT: "Editar",
      ADD: "Agregar",
      UPDATE: "Actualizar",
      SAVE: "Guardar",
    },
  },
  STATUS: {
    ACTIVE: "Activo",
    INACTIVE: "Inactivo",
  },
  COLUMNS: {
    ID: "ID",
    TEMPLATE_NAME: "Nombre template",
    CATEGORY: "Categoría",
    LANGUAGE: "Idioma",
    ACTION_TYPE: "Accion Interna",
    AMOUNT_CHARACTERS: "Num. caracteres en template",
    MAX_CHARACTERS: "Limite caracteres en template",
    ONLY_TICKETS_ON_MESSAGE: "Cuepo Mensaje (Solo tickets)",
    STATUS: "Status",
    ACTIONS: "Acciones",
  },
  TITLE_SIMPLE: "Templates Meta",
};